import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    supplierStatus:false,
    AssignedDeleteSupplierStatus:false,
    AddSupplierStatus:false,
    EditSupplierStatus:false,
    deleteCategory:false,
    deleteSubCategory:false,
    AddContactSupplierStatus:false,
    supplierLimit: null,
    supplierCategories:[],
    supplierSubCategory:[]
};

 const supplierSlice = createSlice({
  name: "venue",
  initialState,
  reducers: {
    deleteSupplierStatus: (state, action) => {
        state.supplierStatus = action.payload;
      },
      assignedDeleteSupplierStatus: (state, action) => {
        state.AssignedDeleteSupplierStatus = action.payload;
      },
      addSupplierStatus: (state, action) => {
        state.AddSupplierStatus = action.payload;
      },
      editSupplierStatus: (state, action) => {
        state.EditSupplierStatus = action.payload;
      },
      addContactSupplierStatus: (state, action) => {
        state.AddContactSupplierStatus = action.payload;
      },
      setSupplierLimit: (state, action) => {
        state.supplierLimit = action.payload;
      },
      setSupplierCategoryList:(state,action)=>{
        state.supplierCategories=action.payload
      },
      setSupplierSubCategory:(state,action)=>{
        state.supplierSubCategory=action.payload
      },
      deleteCategoryStatus: (state, action) => {
        state.deleteCategory = action.payload;
      },
      deleteSubCategoryStatus: (state, action) => {
        state.deleteSubCategory = action.payload;
      },

  },
});

export const {deleteSupplierStatus,assignedDeleteSupplierStatus,addSupplierStatus,editSupplierStatus,addContactSupplierStatus,setSupplierLimit,setSupplierCategoryList,setSupplierSubCategory,deleteCategoryStatus,deleteSubCategoryStatus} = supplierSlice.actions;

export default supplierSlice.reducer;
